import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Negotiation from "@/modules/diplomacy/components/Negotiation.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'StaffMemberNegotiation',
  props: {
    negotiation: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Negotiation, _mergeProps(_ctx.$props, {
        negotiation: __props.negotiation
      }), {
        "target-title": _withCtx(() => [_createVNode(EntityLink, {
          entity: __props.negotiation.target
        }, null, 8, ["entity"])]),
        _: 1
      }, 16, ["negotiation"]);
    };
  }
});